import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Shield = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Shield" {...props}>
    <path d="M10.8857 0.368652C11.6009 0.082638 12.3991 0.0826379 13.1143 0.368652L21.1143 3.56885C22.2529 4.02446 22.9998 5.12757 23 6.354V10.9995C22.9999 14.3402 21.0098 16.9909 18.8906 18.8735C16.7573 20.7686 14.3413 22.0247 13.1523 22.5825C12.4184 22.9269 11.5816 22.9269 10.8477 22.5825C9.6587 22.0247 7.24275 20.7686 5.10938 18.8735C2.99017 16.9909 1.00008 14.3402 1 10.9995V6.354C1.00017 5.12757 1.74707 4.02446 2.88574 3.56885L10.8857 0.368652ZM3.62891 5.42529C3.24942 5.57712 3.00017 5.9453 3 6.354V10.9995C3.00008 13.5031 4.496 15.6525 6.4375 17.3774C8.01845 18.7819 9.79805 19.8133 11 20.4272V2.47607L3.62891 5.42529ZM13 20.4272C14.2019 19.8133 15.9815 18.7819 17.5625 17.3774C19.504 15.6525 20.9999 13.5031 21 10.9995V6.354C20.9998 5.9453 20.7506 5.57712 20.3711 5.42529L13 2.47607V20.4272Z" fill="#000" />
  </StyledIcon>
));

Shield.displayName = 'Shield';

export { Shield };
